import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { isEnabled, FeatureFlag } from '@monolith/legacy/services/features';

const DISCOVERY_SELECTION_PATH = '/shop/discoveryselection';

export function discountsFeatureFlagGuard(
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  if (isEnabled(FeatureFlag.DisableRetailerDiscountsPage)) {
    return next({ path: DISCOVERY_SELECTION_PATH });
  }
  next();
}
